import { countryCodeMap } from 'types/tenants/country-code';
import { getI18n } from 'services/i18n-service';

export const getCountryName = (countryCode: string) => {
  const i18n = getI18n();
  let countryName = countryCodeMap.get(countryCode);
  if (countryName) {
    countryName = i18n.t(countryName);
  }
  return countryName;
};  


// WEBPACK FOOTER //
// ./src/helpers/country-helpers.ts